const experimentation_api_prefix = '/experimentation-api/'
const thor_api_prefix = '/thor-api/'

function hammerUrl(path) {
    return `${thor_api_prefix}api/v1/experiments/hammer${path}`
}

const experimentation_api_urls = {
    baseUrl: 'insights/v1/aggregations/experiments/',
    getBucketAggregations: getBucketAggregationsUrl,
    getAttributesAggregations: getAttributesAggregationsUrl,
    getAttributeValuesAggregations: getAttributeValuesAggregationsUrl,
    getIneligibilityReasons: getIneligibilityReasonsUrl,
    listEppoExperiments: experimentation_api_prefix + 'eppo/v1/experiments'
}

function getBucketAggregationsUrl(experimentKey, environment, startDate, endDate) {
    let url = experimentation_api_prefix + experimentation_api_urls.baseUrl + experimentKey + "/buckets?"
    if (environment) {
        url += "environment=" + environment + "&"
    }
    if (startDate) {
        url += "startAggregationDateHour=" + startDate + "&"
    }
    if (endDate) {
        url += "endAggregationDateHour=" + endDate + "&"
    }
    return url
}

function getAttributesAggregationsUrl(experimentKey, environment, startDate, endDate) {
    let url = experimentation_api_prefix + experimentation_api_urls.baseUrl + experimentKey + "/attributes?"
    if (environment) {
        url += "environment=" + environment + "&"
    }
    if (startDate) {
        url += "startAggregationDateHour=" + startDate + "&"
    }
    if (endDate) {
        url += "endAggregationDateHour=" + endDate + "&"
    }
    return url
}

function getAttributeValuesAggregationsUrl(experimentKey, attribute, environment, startDate, endDate, bucketKey = undefined, reasonIneligible = undefined) {
    let url = experimentation_api_prefix + experimentation_api_urls.baseUrl + experimentKey + "/attributes/" + attribute + "/values?"
    if (environment) {
        url += "environment=" + environment + "&"
    }
    if (startDate) {
        url += "startAggregationDateHour=" + startDate + "&"
    }
    if (endDate) {
        url += "endAggregationDateHour=" + endDate + "&"
    }
    if (bucketKey) {
        url += "bucketKey=" + bucketKey + "&"
    }
    if (reasonIneligible) {
        url += "reasonIneligible=" + reasonIneligible + "&"
    }
    return url
}

function getIneligibilityReasonsUrl(experimentKey, environment, startDate, endDate) {
    let url = experimentation_api_prefix + experimentation_api_urls.baseUrl + experimentKey + "/ineligibilityReasons?"
    if (environment) {
        url += "environment=" + environment + "&"
    }
    if (startDate) {
        url += "startAggregationDateHour=" + startDate + "&"
    }
    if (endDate) {
        url += "endAggregationDateHour=" + endDate + "&"
    }
    return url
}

// Endpoint map for the Thor API. Paths mirror the thor-api-service controllers
// (com.tripadvisor.thor.api.controller.*), base `/api/v1/experiments` unless noted.
const thor_experiments = thor_api_prefix + 'api/v1/experiments';

const thor_api_urls = {
    // ── Experiments (ExperimentController) ──────────────────────────────────
    listAllExperiments: thor_experiments + '?size=10000000',
    listExperiments: thor_experiments,
    createExperiment: thor_experiments + '/',
    experiment: (key) => `${thor_experiments}/${key}`,
    experimentArchived: (key) => `${thor_experiments}/${key}/archived`,
    cloneExperiment: (key) => `${thor_experiments}/${key}/clone`,
    resetExperiment: (key) => `${thor_experiments}/${key}/reset`,
    resurrectExperiment: (key) => `${thor_experiments}/${key}/resurrect`,
    startExperiment: (key) => `${thor_experiments}/${key}/start`,
    pauseExperiment: (key) => `${thor_experiments}/${key}/pause`,
    experimentState: (key) => `${thor_experiments}/${key}/state`,
    validateExperiment: (key) => `${thor_experiments}/${key}/validate`,
    scheduleExperiment: (key) => `${thor_experiments}/${key}/schedule`,
    experimentAnalysis: (key) => `${thor_experiments}/${key}/analysis`,
    bucketComparisonsMode: (key, mode) => `${thor_experiments}/${key}/bucketComparisons/${mode}`,
    rawDecisionsFlag: (key, flag) => `${thor_experiments}/${key}/rawDecisionsFlag/${flag}`,
    forcedBucketsSkipAudience: (key, flag) => `${thor_experiments}/${key}/forcedBucketsSkipAudience/${flag}`,
    // ── Outcome / result (ExperimentResultController) ───────────────────────
    experimentResult: (key) => `${thor_experiments}/${key}/result`,
    // ── Stakeholders / audit (change log) / classification ──────────────────
    experimentStakeholders: (key) => `${thor_experiments}/${key}/stakeholders`,
    experimentExclusionGroups: (key) => `${thor_experiments}/${key}/exclusionGroups`,
    experimentAudit: (key) => `${thor_experiments}/${key}/audit`,
    experimentClassification: (key) => `${thor_experiments}/${key}/classification`,
    // ── Buckets (BucketController) ──────────────────────────────────────────
    experimentBuckets: (experimentKey) => `${thor_experiments}/${experimentKey}/buckets`,
    experimentBucket: (experimentKey, bucketId) => `${thor_experiments}/${experimentKey}/buckets/${bucketId}`,
    // ── Variables (VariableController / VariableValueController) ─────────────
    experimentVariables: (key) => `${thor_experiments}/${key}/variables`,
    experimentVariable: (key, variableId) => `${thor_experiments}/${key}/variables/${variableId}`,
    experimentVariableValues: (key) => `${thor_experiments}/${key}/variableValues`,
    experimentVariableValuesByBucket: (key, bucketId) => `${thor_experiments}/${key}/variableValues/${bucketId}`,
    // ── Metrics catalog (MetricsRepoController) ─────────────────────────────
    metricsRepo: `${thor_api_prefix}api/v1/metrics`,
    // ── Metrics (MetricController) ──────────────────────────────────────────
    experimentMetrics: (key) => `${thor_experiments}/${key}/metrics`,
    experimentMetricsBatch: (key) => `${thor_experiments}/${key}/metricsBatch`,
    experimentMetric: (key, metricId) => `${thor_experiments}/${key}/metrics/${metricId}`,
    metricUpPriority: (key, metricId) => `${thor_experiments}/${key}/metrics/${metricId}/upPriority`,
    metricDownPriority: (key, metricId) => `${thor_experiments}/${key}/metrics/${metricId}/downPriority`,
    metricMoveToTop: (key, metricId) => `${thor_experiments}/${key}/metrics/${metricId}/moveToTop`,
    metricsRearrange: (key) => `${thor_experiments}/${key}/metrics/rearrange`,
    // ── Audiences (ExperimentAudienceController / AudienceController) ────────
    experimentAudiences: (experimentKey) => `${thor_experiments}/${experimentKey}/experimentAudiences`,
    experimentAudiencesForDropdown: (key) => `${thor_experiments}/${key}/experimentAudiencesForDropdown`,
    experimentAudience: (key, experimentAudienceId) => `${thor_experiments}/${key}/experimentAudiences/${experimentAudienceId}`,
    audiences: thor_experiments + '/audiences',
    audience: (audienceId) => `${thor_experiments}/audiences/${audienceId}`,
    audienceAttributes: thor_experiments + '/audienceAttributes',
    audienceOperations: thor_experiments + '/audiences/operations',
    // ── Attributes (AttributeController) ────────────────────────────────────
    attributes: thor_experiments + '/attributes',
    attribute: (attributeId) => `${thor_experiments}/attributes/${attributeId}`,
    // ── Attribute Values (AttributeValueController) ──────────────────────────
    attributeValuesByAttribute: (attributeId) => `${thor_experiments}/attributeValues/${attributeId}`,
    attributeValue: (attributeValueId) => `${thor_experiments}/attributeValues/${attributeValueId}`,
    attributeValuesCreate: thor_experiments + '/attributeValues',
    // ── Audience Values (AudienceValueController) ────────────────────────────
    audienceValuesByAudience: (audienceId) => `${thor_experiments}/audienceValues/${audienceId}`,
    audienceValuesBase: thor_experiments + '/audienceValues',
    // ── Segments (SegmentController) ────────────────────────────────────────
    segments: thor_experiments + '/segments',
    experimentSegments: (experimentKey) => `${thor_experiments}/${experimentKey}/segments`,
    experimentSegment: (key, segmentId) => `${thor_experiments}/${key}/segments/${segmentId}`,
    // ── Qualifiers (QualifierController + HeimdallController) ──────────────
    experimentQualifiers: (key) => `${thor_experiments}/${key}/qualifiers`,
    experimentQualifier: (key, qualifierKey) => `${thor_experiments}/${key}/qualifiers/${qualifierKey}`,
    eligibleQualifiers: thor_api_prefix + 'heimdall/eligible-qualifiers',
    // ── Overrides / forced buckets (ForcedBucketController) ─────────────────
    forcedBuckets: (key) => `${thor_experiments}/${key}/forcedBuckets`,
    forcedBucket: (key, userId) => `${thor_experiments}/${key}/forcedBuckets/${userId}`,
    // ── Reviews (ExperimentReviewController / ReviewTemplateController) ──────
    experimentReviews: (experimentKey) => `${thor_experiments}/${experimentKey}/reviews`,
    experimentReviewTemplates: (experimentKey, reviewTemplate) => `${thor_experiments}/${experimentKey}/review-template/${reviewTemplate}`,
    // ── Instrumentation (InstrumentationInstructionsController) ─────────────
    instrumentationInstructions: (experimentKey) => `${thor_experiments}/${experimentKey}/instrumentation-instructions`,
    // ── Profile (ProfileController) ─────────────────────────────────────────
    profile: thor_api_prefix + 'profile',
    // ── Exclusion Groups (ExclusionGroupController) ──────────────────────────
    allExclusionGroups: thor_experiments + '/exclusionGroups',
    exclusionGroup: (id) => `${thor_experiments}/exclusionGroups/${id}`,
    exclusionGroupExperiments: (id) => `${thor_experiments}/experimentExclusionGroups/${id}`,
    exclusionGroupEligibleExperiments: thor_experiments + '/experimentExclusionGroups/eligibleExperiments',
    experimentInExclusionGroup: (experimentKey, groupId) => `${thor_experiments}/${experimentKey}/experimentExclusionGroups/${groupId}`,
    // ── Archived experiments (Resurrector) ──────────────────────────────────
    listArchivedExperiments: thor_experiments + '?archived=true&size=10000000',
    // ── Hammer (HammerController) — no MSAL, uses URL-IDENTIFIER header ──────
    hammerExperiments: (environment, userId, taUnique) =>
        hammerUrl(`?environment=${encodeURIComponent(environment)}&userId=${encodeURIComponent(userId)}&taUnique=${encodeURIComponent(taUnique)}`),
    hammerUpsertForcedBucket: (key, bucketId) =>
        hammerUrl(`/${key}/forcedBucket/${bucketId}`),
    hammerDeleteForcedBucket: (key) =>
        hammerUrl(`/${key}/forcedBucket`),
    hammerClearAllForcedBuckets: (environment) =>
        hammerUrl(`/forcedBucket/${environment}`),
}

const instrumentationSources = [
    { value: 'b2bhotels_ba-aggregation', label: 'b2bhotels/ba-aggregation' },
    { value: 'bbml_solution-selection', label: 'bbml/solution-selection' },
    { value: 'commerce-sox_commerce-links', label: 'commerce-sox/commerce-links' },
    { value: 'commerce-sox_hotel-auction-service', label: 'commerce-sox/hotel-auction-service' },
    { value: 'core-presentation_serverui-core', label: 'core-presentation/serverui-core' },
    { value: 'core-presentation_tutorial_app-presentation-service', label: 'core-presentation/tutorial/app-presentation-service' },
    { value: 'eat-b2c_restaurant-presentation', label: 'eat-b2c/restaurant-presentation' },
    { value: 'eat-b2c_restaurant-shelf', label: 'eat-b2c/restaurant-shelf' },
    { value: 'eat-b2c_restaurantavailabilitycheck', label: 'eat-b2c/restaurantavailabilitycheck' },
    { value: 'eat-b2c_restaurantcommerceselection', label: 'eat-b2c/restaurantcommerceselection' },
    { value: 'eat-b2c_rss', label: 'eat-b2c/rss' },
    { value: 'exp-ta_exp-checkout-service', label: 'exp-ta/exp-checkout-service' },
    { value: 'exp-ta_exp-presentation', label: 'exp-ta/exp-presentation' },
    { value: 'experimentation_ab-testing', label: 'experimentation/ab-testing' },
    { value: 'flights_flightsearch', label: 'flights/flightsearch' },
    { value: 'hospitality-solutions_platform_b2b-management-center-app-presentation', label: 'hospitality-solutions/platform/b2b-management-center-app-presentation' },
    { value: 'hotel-data-aggregation-layer_hdal-aws-migration-shim', label: 'hotel-data-aggregation-layer/hdal-aws-migration-shim' },
    { value: 'hotel-data-aggregation-layer_hotel-presentation', label: 'hotel-data-aggregation-layer/hotel-presentation' },
    { value: 'hotels_hotel-meta-discovery', label: 'hotels/hotel-meta-discovery' },
    { value: 'hotels_hotelpresentation', label: 'hotels/hotelpresentation' },
    { value: 'hotels_hotelsgeo', label: 'hotels/hotelsgeo' },
    { value: 'hotels_mediaalbum', label: 'hotels/mediaalbum' },
    { value: 'ind_trips', label: 'IND/trips' },
    { value: 'media_primary-photo', label: 'media/primary-photo' },
    { value: 'mlplat-solution-selection-service', label: 'mlplat-solution-selection-service' },
    { value: 'mobile_app-config-service', label: 'mobile/app-config-service' },
    { value: 'restaurant-solutions_rs-ads-delivery', label: 'restaurant-solutions/rs-ads-delivery' },
    { value: 'searchnav_mixer', label: 'searchnav/mixer' },
    { value: 'searchnav_services_serp', label: 'searchnav/services/serp' },
    { value: 'searchnav_services_typeahead', label: 'searchnav/services/typeahead' },
    { value: 'seo-dev_internallinks', label: 'seo-dev/internallinks' },
    { value: 'sponsored-placements_hsp-aws-gw', label: 'sponsored-placements/hsp-aws-gw' },
    { value: 'sponsored-placements_hsp-delivery', label: 'sponsored-placements/hsp-delivery' },
    { value: 'sponsored-placements_sp-tracking', label: 'sponsored-placements/sp-tracking' },
    { value: 'taps_ad-context', label: 'taps/ad-context' },
    { value: 'taps_da-delivery', label: 'taps/da-delivery' },
    { value: 'taps_sponsorship-manager', label: 'taps/sponsorship-manager' },
    { value: 'tpg_optimus-benefits', label: 'tpg/optimus-benefits' },
    { value: 'tr-srctr (trtop)', label: 'tr-srctr (TRTOP)' },
    { value: 'traveler-experience_services_graphql-decorator', label: 'traveler-experience/services/graphql-decorator' },
    { value: 'traveler-experience_services_reviews-proxy', label: 'traveler-experience/services/reviews-proxy' },
    { value: 'trip-ads_ad-selection', label: 'trip-ads/ad-selection' },
    { value: 'tripadv_trips-backenddocker', label: 'tripadv/trips-backenddocker' },
    { value: 'ttd_exp-ta-shelf-service', label: 'TTD/exp-ta-shelf-service' },
    { value: 'vr_rental-information', label: 'vr/rental-information' },
    { value: 'web', label: 'web' },
    { value: 'hac_migration-gateway', label: 'hotels/hac-migration-gateway' }
]

const instrumentationPatterns = [
    {value: 'evaluate_inline', label: 'Evaluate Inline'},
    {value: 'separate_bucketing_recording', label: 'Separate Bucketing + Recording'},
    {value: 'qualifiers', label: 'Qualifiers'},
]

const pagesUnderTest = [
    { value: 'articles', label: 'Articles' },
    { value: 'experience_booking', label: 'Experience Booking' },
    { value: 'experience_detail', label: 'Experience Detail' },
    { value: 'experience_list', label: 'Experience List' },
    { value: 'experience_product_detail', label: 'Experience Product Detail' },
    { value: 'experience_product_list', label: 'Experience Product List' },
    { value: 'flights', label: 'Flights' },
    { value: 'forums', label: 'Forums' },
    { value: 'hotel_detail', label: 'Hotel Detail' },
    { value: 'hotel_list', label: 'Hotel List' },
    { value: 'login_&_registration', label: 'Login & Registration' },
    { value: 'media_viewer', label: 'Media Viewer' },
    { value: 'nearby', label: 'Nearby' },
    { value: 'other', label: 'Other' },
    { value: 'restaurant_detail', label: 'Restaurant Detail' },
    { value: 'restaurant_list', label: 'Restaurant List' },
    { value: 'search_&_typeahead', label: 'Search & Typeahead' },
    { value: 'tourism', label: 'Tourism' },
    { value: 'trips', label: 'Trips' },
    { value: 'user_review', label: 'User Review' },
    { value: 'vacation_rentals', label: 'Vacation Rentals' }
];
const reviewTypeMapping = {
    'design_review': 'engineer_design_review',
    'instrumentation': 'engineer_instrumentation_signoff',
    'cleanup': 'engineer_cleanup_signoff'
}

export {experimentation_api_urls, thor_api_urls, instrumentationSources, instrumentationPatterns, pagesUnderTest, reviewTypeMapping}